(() => {
  if (window.__cmCardSizes) return;
  window.__cmCardSizes = true;

  const packFromUrl = () => {
    const pack = new URLSearchParams(window.location.search).get('pack') || '';
    return pack.toLowerCase();
  };

  const isAvailable = (btn) => btn && !btn.disabled && btn.getAttribute('data-available') !== 'false';

  const applySize = (btn) => {
    const root = btn.closest('[data-cm-card-sizes]');
    const form = btn.closest('form');
    if (!root || !form) return;

    const available = isAvailable(btn);
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = btn.getAttribute('data-variant-id');
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    root.querySelectorAll('.cm-card-size').forEach((el) => {
      el.classList.toggle('is-on', el === btn);
    });

    const addBtn = form.querySelector('[name="add"], .add-to-cart-button');
    if (addBtn) {
      addBtn.disabled = !available;
      const label = addBtn.querySelector('.add-to-cart-text__content');
      const text = available ? root.getAttribute('data-add-text') : root.getAttribute('data-sold-text');
      if (label && text) label.textContent = text;
    }

    form.querySelectorAll('quantity-selector-component input, quantity-selector-component button').forEach((el) => {
      el.disabled = !available;
    });

    const card = btn.closest('product-card') || form.closest('product-card');
    const price = btn.getAttribute('data-price');
    if (card && price) {
      card.querySelectorAll('product-price .price').forEach((el) => {
        if (el.closest('.compare-at-price, .unit-price')) return;
        el.textContent = price;
      });
    }

    const url = btn.getAttribute('data-url');
    if (card && url) {
      const link = card.querySelector('a.product-card__link');
      if (link) link.setAttribute('href', url);
    }
  };

  const firstAvailable = (root) =>
    [...root.querySelectorAll('.cm-card-size')].find((btn) => isAvailable(btn));

  const preselectFromUrl = () => {
    const pack = packFromUrl();
    document.querySelectorAll('[data-cm-card-sizes]').forEach((root) => {
      let match = null;
      if (pack) {
        match = [...root.querySelectorAll('.cm-card-size')].find((btn) => {
          const title = (btn.getAttribute('data-title') || '').toLowerCase();
          return isAvailable(btn) && (title === pack || title.includes(pack));
        });
      }
      const current = root.querySelector('.cm-card-size.is-on');
      if (!match && !isAvailable(current)) {
        match = firstAvailable(root);
      }
      if (match) applySize(match);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest('[data-cm-card-sizes] .cm-card-size');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      applySize(btn);
    },
    true
  );

  document.addEventListener('cm:packchange', preselectFromUrl);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselectFromUrl, { once: true });
  } else {
    preselectFromUrl();
  }
})();
